import React, { useEffect, useLayoutEffect, useState } from "react";

import { useWizard } from "../../wizard";

import { StepContainer, InfoBox } from "../index";

import { contentApi } from "../../services/contentApi";

import { contentKeys } from "../../constants/contentKeys";

const formatDate = (dateStr: string) => {
  const [y, m, d] = dateStr.split("-").map(Number);

  const date = new Date(y, m - 1, d);

  const months = [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december",
  ];

  return `${d}. ${months[m - 1]} ${y}`;
};

const ConfirmationStep: React.FC = () => {
  const { selfServiceData, sessionId, updateSelfServiceData } = useWizard();

  const [title] = useState("Tiden er reserveret");

  const [body, setBody] = useState<string[] | null>(null);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.confirmation).then((c) => {
      if (c?.body && c.body.length > 0) {
        setBody(c.body);
      }
    });
  }, []);

  useEffect(() => {
    console.log("ConfirmationStep selfServiceData:", selfServiceData);
  }, [selfServiceData]);

  useLayoutEffect(() => {
    updateSelfServiceData("isCompleted", true);
  }, [updateSelfServiceData]);

  const { passportFor, hasOldPassport, previousCitizenship, date, time } =
    selfServiceData;

  return (
    <StepContainer title={title}>
      {body && (
        <InfoBox type="success">
          {body.map((p, i) => (
            <p key={i}>{p}</p>
          ))}
        </InfoBox>
      )}

      {(selfServiceData.locationName || date || time) && (
        <>
          <h3>Din reservation</h3>

          <ul className="summary-list">
            {selfServiceData.locationName && (
              <li>
                <span className="label">Sted</span>

                <span className="value">{selfServiceData.locationName}</span>
              </li>
            )}

            {date && (
              <li>
                <span className="label">Dato</span>

                <span className="value">{formatDate(date)}</span>
              </li>
            )}

            {time && (
              <li>
                <span className="label">Tid</span>

                <span className="value">kl. {time}</span>
              </li>
            )}
          </ul>
        </>
      )}

      <div className="info-box">
        <strong>Husk at medbringe:</strong>

        <ul>
          {hasOldPassport && <li>Dit seneste pas</li>}

          {!hasOldPassport && <li>Anden billedlegitimation (fx kørekort)</li>}

          {previousCitizenship && (
            <li>Dokumentation for dansk statsborgerskab</li>
          )}

          {passportFor === "child" && <li>Barnets dåbs- eller navneattest</li>}
        </ul>
      </div>

      <p
        data-testid="confirmation-session-id"
        style={{ marginTop: "2rem", fontSize: "0.85rem", color: "#d0d0d0" }}
      >
        <span style={{ opacity: 0.5 }}>
          <strong>Reference:</strong> {sessionId?.slice(-5) || ""}
        </span>
      </p>
    </StepContainer>
  );
};

export default ConfirmationStep;
